import {useEffect, useState} from 'react'
import {Button, Card, Col, InputNumber, Row, message} from "antd";
import {BankSelectWidget} from "../widget/BankSelectWidget";
import {getBankBalances, insertBankTranfer} from "../../api/Api";

export const BankTransfer = ({refresh, onRefresh, onApiFail, props}) => {
    const [source, setSource] = useState(undefined);
    const [dest, setDest] = useState(undefined);
    const [amount, setAmount] = useState(undefined);
    const [balanceMap, setBalanceMap] = useState({});
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        getBankBalances().then(r => {
            const nextMap = {};
            r.forEach(account => {
                nextMap[account.id] = account;
            })
            setBalanceMap(nextMap);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [source, dest, refresh, onApiFail])

    const onSourceChange = (val) => {
        setSource(val);
        if (balanceMap[val]) {
            console.log(`source has ${JSON.stringify(balanceMap[val])}`);
        }
    }

    const onDestChange = (val) => {
        setDest(val);
        if (balanceMap[val]) {
            console.log(`dest has ${balanceMap[val].amount}`);
        }
    }

    const onAmountChange = (val) => {
        setAmount(val);
    }

    const clearForm = () => {
        setSource(undefined);
        setDest(undefined);
        setAmount(undefined);
    }

    const onTransfer = () => {
        insertBankTranfer(source, dest, amount).then(r => {
            messageApi.open({
                type: 'success',
                content: 'Transfer Succeeded'
            })
            if (onRefresh) onRefresh();
        }).catch(e => {
            messageApi.open({
                type: 'error',
                content: 'Transfer Failed'
            })
        }).finally(() =>{
            clearForm();
        })
    }

    const bankStyle = {
        width: 150
    }

    const sourceUndefined = source === undefined;
    const destUndefined = dest === undefined;
    const amountInvalid = amount === undefined || amount === null || amount < 0;

    let sourceBalance = <div>$ 0.00</div>
    let destBalance = <div>$ 0.00</div>
    let srcBalance
    if ((balanceMap[source]) && (balanceMap[source].amount)) {
        srcBalance = balanceMap[source].amount
        sourceBalance = <div>{`$ ${srcBalance}`}</div>
    }
    let dstBalance;
    if ((balanceMap[dest]) && (balanceMap[dest].amount)) {
        dstBalance = balanceMap[dest].amount
        destBalance = <div>{`$ ${dstBalance}`}</div>
    }

    const transferDisabled = sourceUndefined || destUndefined || source === dest || amountInvalid || srcBalance < amount;

    const warningStyle = {color: 'red'}
    const balanceWarning = <div style={warningStyle}>Source has insufficient funds</div>

    return <div style={{textAlign: 'left'}}>
        {contextHolder}
        <Card title={'Bank Transfer'}>
            <Row>
                <Col span={6}><BankSelectWidget style={bankStyle} altText={'From'} accountId={source} setAccountId={onSourceChange} onApiFail={onApiFail} /></Col>
                {sourceUndefined === false &&
                    <Col span={12}>{sourceBalance}</Col>
                }
            </Row>
            <p/>
            <Row>
                <Col span={6}><BankSelectWidget style={bankStyle} altText={'To'}  accountId={dest} setAccountId={onDestChange} onApiFail={onApiFail} /></Col>
                {destUndefined === false &&
                    <Col span={12}>{destBalance}</Col>
                }
            </Row>
            <p/>
            <InputNumber style={bankStyle} placeholder={"amount"} addonBefore={"$"} onChange={onAmountChange} precision={2} min={0} value={amount} />
            <p/>
            <Button disabled={transferDisabled} onClick={onTransfer}>Transfer</Button>
            <p/>
            {(srcBalance < amount) && balanceWarning
            }
        </Card>
    </div>
}